export const STEPS = [
    {
        value: 'start',
        label: 'revocation.steps.start',
        component: 'Start',
        hideBar: true
    },
    {
        value: 'notice',
        label: 'revocation.steps.notice',
        onlyFor: ['revocation'],
        component: 'Notice',
    },
    {
        value: 'returnInfo',
        label: 'revocation.steps.return_info',
        onlyFor: ['returnInfo'],
        component: 'ReturnInfo',
    },
    {
        value: 'findOrder',
        label: 'revocation.steps.find_order',
        component: 'FindOrder',
    },
    {
        value: 'cancelOrder',
        label: 'revocation.steps.cancel_order',
        onlyFor: ['revocation'],
        component: 'CancelOrder',
    },
    {
        value: 'productList',
        label: 'revocation.steps.product_list',
        onlyFor: ['rma'],
        component: 'ProductList',
    },
    {
        value: 'successPage',
        label: 'revocation.steps.success_page',
        onlyFor: ['rma', 'revocation'],
        component: 'SuccessPage',
        hideBar: true,
    },
    {
        value: 'errorPage',
        label: 'revocation.steps.error_page',
        onlyFor: ['rma', 'revocation'],
        visible: false,
        hideBar: true,
        component: 'ErrorPage',
    }
];